import { FC } from 'react';
import { OrderList } from './orders/OrderList';

export const OrdersCard: FC = () => {
    return (
        <div className="relative flex flex-col items-center p-4 card-transparent rounded-2xl min-h-[524px]">
            <span className="mb-4 mr-auto t__subtitle--s2 text-grey-10">Your Orders</span>
            <OrderList />
        </div>
    );
};
